module.exports = __webpack_public_path__ + "img/device.3318145b.png";